<template>
    <div>
        <div class="loader">
            <span v-for="n in 7" :key="n"></span>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
$loader-duration: 1.2s;
$loader-dots: 7;
.loader {
    $block: &;
    position: relative;
    width: 24px;
    height: 24px;
    animation: rotateLoader 15s linear infinite;
    span {
        position: absolute;
        top: 50%;
        height: 4px;
        width: 50%;
        left: 50%;
        margin-top: -2px;
        transform-origin: left center;
        @for $i from 1 to 11 {
            &:nth-child(#{$i}) {
                transform: rotate(((360deg/$loader-dots)  * $i) );
                &::after {
                    animation-delay: ($loader-duration * $i / $loader-dots) - $loader-duration;
                }
            }
        }
        &::after {
            content: '';
            position: absolute;
            right: 4px;
            top: 0;
            height: 4px;
            width: 4px;
            border-radius: 4px;
            background-color: $color-black;
            transform-origin: right center;
            animation: showDot $loader-duration $ease-out-quad both infinite;
        }


    }
}

@keyframes rotateLoader {
    0% {
        transform: none;
    }
    100% {
        transform: rotate(-360deg);
    }
}

@keyframes showDot {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    45%, 60% {
        transform: scale(1);
        opacity: 1;
    }
    100% {
        transform: scale(0);
        opacity: 0;
    }
}
</style>